// extracted by mini-css-extract-plugin
export default {"stepIcon":"Stepper_stepIcon__O5viK","stepper":"Stepper_stepper__5VxCx"};